import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbySeo } from 'gatsby-plugin-next-seo';

function Seo({ description, lang, meta, keywords, title, author, imagePath, pageUrl, noindex}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const url = site.siteMetadata.siteUrl + pageUrl;
  const fullImagePath = site.siteMetadata.siteUrl + imagePath;

  return (
    <GatsbySeo
      noindex={noindex}
      nofollow={noindex}
      title={title}
      description={description}
      language={lang}
      openGraph={{
        url: url,
        title: title,
        keywords: keywords,
        description: metaDescription,
        images: [
          {
            url: fullImagePath,
          }
        ],
        site_name: site.siteMetadata.title,
        locale: `en_AU`,
        type: 'website'
      }}
    />
  )
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
  author: PropTypes.string,
  pageUrl: PropTypes.string,
  noindex: PropTypes.bool,
}

export default Seo
